export function entry() {
  let entry = document.querySelector('.js-entry');
  let entryTrigger = document.querySelector('.js-entryTrigger');
  let body = document.querySelector('body');

  entryTrigger.addEventListener('click', ()=>{
    entry.classList.add('is-active');
    body.classList.add('is-active');
  });
}
